import { dataLayer } from 'dls-icons-data'
import { createIcon } from '../common'

const IconLayer = /*#__PURE__*/createIcon(dataLayer)
export default IconLayer
